import { render, staticRenderFns } from "./FilesAndPictures.vue?vue&type=template&id=61388bb8&scoped=true&"
import script from "./FilesAndPictures.vue?vue&type=script&lang=js&"
export * from "./FilesAndPictures.vue?vue&type=script&lang=js&"
import style0 from "./FilesAndPictures.vue?vue&type=style&index=0&id=61388bb8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61388bb8",
  null
  
)

export default component.exports